import React, { useState, useRef, useCallback } from 'react';
import { Button } from 'react-bootstrap';

const ChatInput = ({ onSend, loading, disabled }) => {
  const [value, setValue] = useState('');
  const textareaRef = useRef(null);

  const handleSend = useCallback(() => {
    const trimmed = value.trim();
    if (!trimmed || loading || disabled) return;
    onSend(trimmed);
    setValue('');
    textareaRef.current?.focus();
  }, [value, loading, disabled, onSend]);

  const handleKeyDown = (e) => {
    // Send on Enter (not Shift+Enter)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chat-input-area">
      <textarea
        ref={textareaRef}
        className="chat-textarea"
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask about your portfolio, market data, news, or risk... (Enter to send)"
        rows={2}
        disabled={disabled || loading}
        maxLength={2000}
      />
      <Button
        variant="primary"
        className="chat-send-btn"
        onClick={handleSend}
        disabled={!value.trim() || loading || disabled}
        title="Send message"
      >
        {loading ? '⏳' : '➤'}
      </Button>
    </div>
  );
};

export default ChatInput;
